import { ResponseEntity } from "domain/entity/Common/ResponseEntity";
import { InterfaceMonitoringDtlEntity } from "domain/entity/InterfaceMonitoring/InterfaceMonitoringDtlEntity";
import { InterfaceMonitoringEntity } from "domain/entity/InterfaceMonitoring/InterfaceMonitoringEntity";
import { InterfaceMonitoringSearchCriteria } from "domain/entity/InterfaceMonitoring/InterfaceMonitoringSearchCriteria";
import { InterfaceTypeEntity } from "domain/entity/InterfaceType/InterfaceTypeEntity";
import { axiosGetData, axiosPostData } from "../axios/AxiosBasicImpl";
import collectionAxiosInstance from "../axios/collectionAxiosInstance";
import { InterfaceMonitoringRepository } from "./InterfaceMonitoringRepo";

/**
 * For template
 * @returns 
 */
export const InterfaceMonitoringRepoImpl = (): InterfaceMonitoringRepository => {
    const searchUrl = '/v1/ebisSearchMonitoringList';
    const searchDetailUrl = '/v1/interfaceMonitoringDetailSearch';
    const searchComboboxUrl = '/v1/interfaceTypeCombobox';

    const searchEbisInterfaceMonitoringList = async (criteria: InterfaceMonitoringSearchCriteria): Promise<InterfaceMonitoringEntity[]> => {

        return await axiosPostData(collectionAxiosInstance, `${searchUrl}`, criteria).then(res => {
            const data = res.data;
            return data;
        }).catch(err => {
            return [];
        });
    }

    const searchInterfaceMonitoringDetail = async (criteria: InterfaceMonitoringSearchCriteria): Promise<InterfaceMonitoringDtlEntity[]> => {

        return await axiosPostData(collectionAxiosInstance, `${searchDetailUrl}`, criteria).then(res => {
            const data = res.data;
            return data;
        }).catch(err => {
            return [];
        });
    }

    const searchInterfaceTypeCombobox = async (code: string): Promise<InterfaceTypeEntity[]> => {

        return await axiosGetData(collectionAxiosInstance, `${searchComboboxUrl}/${code}`, []).then(res => {
            const data = res.data;
            return data;
        }).catch(err => {
            return [];
        });
    }

    const onEbisResend = async (row: InterfaceMonitoringEntity[]): Promise<ResponseEntity> => {
        const ebisResendUrl = "/v1/ebisResend";
        return await axiosPostData(collectionAxiosInstance, `${ebisResendUrl}`, row);
    }

    const onBankResend = async (row: InterfaceMonitoringEntity): Promise<ResponseEntity> => {
        const bankResendUrl = "/v1/bankResend";
        return await axiosPostData(collectionAxiosInstance, `${bankResendUrl}`, row);
    }

    const onResendAll = async (row: InterfaceMonitoringEntity[]): Promise<ResponseEntity> => {
        const resendUrl = "/v1/bankResendAll";
        return await axiosPostData(collectionAxiosInstance, `${resendUrl}`, row);
    }

    return {
        searchEbisInterfaceMonitoringList: searchEbisInterfaceMonitoringList,
        searchInterfaceMonitoringDetail: searchInterfaceMonitoringDetail,
        searchInterfaceTypeCombobox: searchInterfaceTypeCombobox,
        onEbisResend: onEbisResend,
        onBankResend: onBankResend,
        onResendAll: onResendAll
    }
}